import API from "./api";

import { UserSearchPayload, UserStatusPayload } from "../models/User";

export const GetUserList = (configUrl: string, payload: UserSearchPayload) => 
  API.post(`${configUrl}api/Admin/users/search`, payload);

export const GetRoles = (configUrl: string) =>
 API.get(`${configUrl}api/Master/Roles`);


export const GetHealthPlanMaster = (configUrl: string) =>
   API.get(`${configUrl}api/ReferralService/HealthPlan`);


export const UpdateUserStatus=(configUrl: string, payload: UserStatusPayload)=>
  API.put(`${configUrl}api/Admin/UpdateUserStatus`, payload);